import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  mapStateToProps,
  registerAdminReducer,
  mapDispatchToProps,
} from "./AdminRegistration.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import AdminRegistration from "../../library/AdminRegistration/AdminRegistration";
import { withRouter } from "react-router-dom";
import { modalHeaders, modalType } from "../../../modules/constants";
import history from "../../../modules/history";
import { useTranslation } from "react-i18next";

export const SmartAdminRegistration = (props) => {
  const {
    showAdminReg,
    setOpenAuthModal,
    verifyToken,
    isTokenValid,
    submittedChange,
    closeModalGoHome,
    registerAdmin,
    resetState,
  } = props;

  const { t } = useTranslation();

  const token = props.match?.params.token;
  const email = props.match?.params.email;
  const [errorMessage, setErrorMessage] = useState(null);

  const openModalRecover = useCallback(() => {
    setOpenAuthModal(
      modalType.adminRegistrationProcess,
      t("appText.auth.setup.account.title")
    );
  }, [setOpenAuthModal]);

  const checkToken = useCallback(() => {
    verifyToken(token);
  }, [token, verifyToken]);

  const closeModal = () => {
    closeModalGoHome();
  };

  const handleRegister = (
    token,
    email,
    firstName,
    lastName,
    password,
    acceptedTerms
  ) => {
    registerAdmin(
      token,
      email,
      firstName,
      lastName,
      password,
      acceptedTerms
    ).catch((err) => {
      setErrorMessage(err);
    });
  };

  const showLoginModal = (e) => {
    e?.preventDefault();
    history.push("/home");
    setOpenAuthModal(modalType.login, t("appText.login"));
  };

  useEffect(() => {
    openModalRecover();
    if (showAdminReg) checkToken();
  }, [openModalRecover, checkToken]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return showAdminReg ? (
    <AdminRegistration
      isTokenValid={isTokenValid}
      submittedChange={submittedChange}
      showLoginModal={showLoginModal}
      closeModal={closeModal}
      handleRegister={handleRegister}
      errorMessage={errorMessage}
      token={token}
      email={email}
    />
  ) : null;
};

export default dynamic(
  "registerAdminReducer",
  subspaced({
    mapExtraState: (state) => ({
      adminRegisterReducer: state.adminRegisterReducer,
    }),
  }),
  attachReducer(registerAdminReducer)
)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(SmartAdminRegistration))
);
